import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { useWidgetDispatch, useWidgetSelector } from "../../../../store/store";
import { RadioButtonGroup } from "../../../../../RadioButton/RadioButtonGroup";
import { setDueDay } from "../../../../store/actions";
import { State } from "../../../../store/state";
import { AvtaleGiroDatePicker } from "./AvtaleGiroDatePicker/AvtaleGiroDatePicker";
import { formatChargeDay, getEarliestPossibleChargeDate } from "./AvtaleGiroDatePicker/avtalegirodates";
import { RecurringBankDonationForm } from "./RecurringForm";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { AvtaleGiroPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import panes from "../../Panes.module.scss";
import payment from "../PaymentPane.module.scss";
export const AvtaleGiroPane: React.FC<{
  config: AvtaleGiroPaymentMethod;
  referrals: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(42);
  const {
    config,
    referrals
  } = t0;
  const donation = useWidgetSelector(_temp);
  const [chooseChargeDay, setChooseChargeDay] = useState(0);
  const dispatch = useWidgetDispatch();
  let t1;
  let t2;
  if ($[0] !== chooseChargeDay || $[1] !== dispatch) {
    t1 = () => {
      if (chooseChargeDay === 0) {
        dispatch(setDueDay(getEarliestPossibleChargeDate()));
      }
    };
    t2 = [chooseChargeDay, dispatch];
    $[0] = chooseChargeDay;
    $[1] = dispatch;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== config.title) {
    t3 = <h2 className={panes.paneTitle}>{config.title}</h2>;
    $[4] = config.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      paddingTop: 20
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== config.selector_earliest_text) {
    t5 = {
      title: config.selector_earliest_text,
      value: 0
    };
    $[7] = config.selector_earliest_text;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== config.selector_choose_date_text) {
    t6 = {
      title: config.selector_choose_date_text,
      value: 1
    };
    $[9] = config.selector_choose_date_text;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = [t5, t6];
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = option => setChooseChargeDay(option);
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== chooseChargeDay || $[16] !== t7) {
    t9 = <div style={t4}><RadioButtonGroup options={t7} selected={chooseChargeDay} onSelect={t8} /></div>;
    $[15] = chooseChargeDay;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      paddingTop: 40
    };
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== chooseChargeDay) {
    t11 = chooseChargeDay === 0 && <p className={payment.dateText}>{formatChargeDay(getEarliestPossibleChargeDate())}</p>;
    $[19] = chooseChargeDay;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== chooseChargeDay || $[22] !== config.date_selector_configuration) {
    t12 = chooseChargeDay === 1 && <AvtaleGiroDatePicker configuration={config.date_selector_configuration} />;
    $[21] = chooseChargeDay;
    $[22] = config.date_selector_configuration;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <div style={t10}>{t11}{t12}</div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t3 || $[29] !== t9) {
    t14 = <div>{t3}{t9}{t13}</div>;
    $[27] = t13;
    $[28] = t3;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== config.button_text || $[32] !== donation) {
    t15 = <div><RecurringBankDonationForm donation={donation} buttonText={config.button_text} /></div>;
    $[31] = config.button_text;
    $[32] = donation;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== referrals.other_referral_input_placeholder || $[35] !== referrals.referrals_title || $[36] !== referrals.show_referrals) {
    t16 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[34] = referrals.other_referral_input_placeholder;
    $[35] = referrals.referrals_title;
    $[36] = referrals.show_referrals;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t14 || $[39] !== t15 || $[40] !== t16) {
    t17 = <div className={panes.pane}><div className={panes.paneContainer}>{t14}{t15}{t16}</div></div>;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
function _temp(state) {
  return state.donation;
}